/* Installation Guides Accordion */

document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll(
      '.accordion-section.installation-guide .accordion'
    );
  
    accordions.forEach((accordion, index) => {
      const title = accordion.querySelector('.accordion__title');
      const content = accordion.querySelector('.accordion__content');
  
      if (!title || !content) return;
  
      // Accessibility setup
      const contentId = `accordion-content-${index}`;  
      
      content.id = contentId;
      content.setAttribute('aria-hidden', 'true');
  
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', 'false');
      title.setAttribute('aria-controls', contentId);
  
      // initial state (closed)
      content.style.display = 'none';
  
      // Click toggle
      title.addEventListener('click', () => {
        const isOpen = accordion.classList.contains('is-open');
  
        if (isOpen) {
          accordion.classList.remove('is-open');
          content.style.display = 'none';
  
          title.setAttribute('aria-expanded', 'false');
          content.setAttribute('aria-hidden', 'true');
        } else {
          accordion.classList.add('is-open');
          content.style.display = 'block';
  
          title.setAttribute('aria-expanded', 'true');
          content.setAttribute('aria-hidden', 'false');
        }
      });
  
      // Keyboard support
      title.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          title.click();
        }
      });
    });
  });